// ./textSignature/index.tsx
import React, { FC, useState, useRef, useEffect } from 'react';

interface TextSignatureProps {
  onTextChange: (signature: string) => void;
  initialText?: string;
}

export const TextSignature: FC<TextSignatureProps> = ({ onTextChange, initialText = '' }) => {
  const [text, setText] = useState(initialText);
  const [fontFamily, setFontFamily] = useState('Segoe Script');
  const [fontSize, setFontSize] = useState(35);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const fonts = [
    'Brush Script MT',
    'Lucida Handwriting',
    'Vivaldi',
    'Vladimir Script',
    'Segoe Script',
    'Mistral'
  ];

  useEffect(() => {
    renderTextToCanvas();
  }, [text, fontFamily, fontSize]);

  const renderTextToCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Set font first to measure text width
    ctx.font = `${fontSize}px ${fontFamily}`;
    const textWidth = ctx.measureText(text).width;

// Resize canvas
    canvas.width = Math.max(300, textWidth + 40);
    canvas.height = fontSize * 2;

// Redraw everything after resizing
    ctx.font = `${fontSize}px ${fontFamily}`;
    ctx.fillStyle = 'black';
    ctx.textBaseline = 'middle';
    ctx.textAlign = "center";
    ctx.fillText(text, canvas.width / 2, canvas.height / 2);


    // Convert to data URL and notify parent
    const dataUrl = canvas.toDataURL('image/png');
    onTextChange(dataUrl);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const handleFontChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFontFamily(e.target.value);
  };

  const handleSizeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFontSize(parseInt(e.target.value, 10));
  };

  return (
    <div className="text-signature-container">
      <div className="mb-3">
        <input type="text" value={text} onChange={handleTextChange} placeholder="Enter your signature text"
               className="form-control"
        />
        <div className="row my-3">
          <div className="col-md-6">
            <label className="fw-bold small">Font Family</label>
            <select value={fontFamily} onChange={handleFontChange} className="form-select">
              {fonts.map(font => (
                <option key={font} value={font} style={{ fontFamily: font }}>
                  {font}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-5">
            <label className="fw-bold small mb-2">
              Font Size: <span className="badge bg-green fs-6 px-2 py-1">{fontSize}px</span>
            </label>
            <input type="range" min="12" max="72" value={fontSize} onChange={handleSizeChange} className="form-range"/>
          </div>
        </div>
      </div>
      <div className="signature-canvas-control d-flex align-items-center justify-content-center" style={{height:"auto", minHeight:"152px"}}>
        <canvas ref={canvasRef} style={{ width:'auto', height:`${fontSize * 2}px` }}/>
      </div>
    </div>
  );
};
